import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Lightweight in-memory cache so every Navbar/Footer/page mount doesn't refetch
 * /api/settings. Settings rarely change in a single session. The admin "Save"
 * dispatches a `destoel:settings-changed` window event to invalidate.
 */
let _cache = null;
let _inflight = null;
const subscribers = new Set();

function notify() {
  subscribers.forEach((cb) => cb(_cache));
}

async function load() {
  if (_inflight) return _inflight;
  _inflight = api.get("/settings").then(
    (r) => {
      _cache = r.data;
      _inflight = null;
      notify();
      return _cache;
    },
    (e) => {
      _inflight = null;
      throw e;
    },
  );
  return _inflight;
}

export function invalidateSettingsCache() {
  _cache = null;
  load().catch(() => {});
}

if (typeof window !== "undefined") {
  window.addEventListener("destoel:settings-changed", invalidateSettingsCache);
}

export default function useSettings() {
  const [settings, setSettings] = useState(_cache);
  useEffect(() => {
    const cb = (val) => setSettings(val);
    subscribers.add(cb);
    if (!_cache) load().catch(() => {});
    else setSettings(_cache);
    return () => subscribers.delete(cb);
  }, []);
  return settings;
}
